<template>
  <el-dialog
    :visible.sync="dialogTableVisible"
    :append-to-body="true"
    width="30%"
  >
    <span slot="title">{{ title }}</span>
    <span class="dialog-content">{{ content }}</span>
    <span slot="footer">
      <el-button plain size="mini" @click="handleCancel">
        {{ cancelText }}
      </el-button>
      <el-button
        type="primary"
        size="mini"
        :disabled="btnDisabled && isTime"
        @click="handleSuccess"
      >
        {{ successText }}
        <span v-if="btnDisabled && isTime">({{ countdown }})</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "TipDialog",
  props: {},
  data() {
    return {
      dialogTableVisible: false,
      btnDisabled: false,
      countdown: 0,
      timer: null,
      title: "提示",
      content: "提示内容",
      cancelText: "取消",
      successText: "已知晓",
      isTime: false,
    };
  },
  methods: {
    show(row = {}) {
      const defaultConfig = {
        title: "提示",
        content: "提示内容",
        cancelText: "取消",
        successText: "已知晓",
        isTime: false,
      };

      const config = { ...defaultConfig, ...row };
      Object.assign(this, config);

      this.dialogTableVisible = true;

      if (this.isTime) {
        clearInterval(this.timer);
        this.timer = null;
        this.startCountdown();
      }
    },
    startCountdown() {
      this.countdown = 5;
      this.btnDisabled = true;
      this.timer = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown -= 1;
        } else {
          clearInterval(this.timer);
          this.timer = null;
          this.btnDisabled = false;
        }
      }, 1000);
    },
    handleCancel() {
      this.dialogTableVisible = false;
    },
    handleSuccess() {
      this.$emit("success");
      this.dialogTableVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
.dialog-content {
  font-weight: 400;
  font-size: 14px;
  color: #606266;
}
</style>
